import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { History as HistoryIcon, Zap } from "lucide-react";
import api from "@/lib/api";
import { PredictionPill } from "@/components/StatusBadge";

export default function HistoryPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/predictions").then(({ data }) => setItems(data)); }, []);

  return (
    <div data-testid="history-page">
      <p className="vw-label">Prediction History</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-white mt-1 mb-6">Your Predictions</h1>

      {items === null ? (
        <div className="h-32 rounded-2xl bg-slate-800/50 animate-pulse" />
      ) : items.length === 0 ? (
        <div className="vw-card p-10 text-center">
          <HistoryIcon className="mx-auto text-slate-600 mb-3" size={32} />
          <p className="text-slate-400">No predictions yet.</p>
          <button onClick={() => navigate("/predictor")} className="vw-btn-primary mt-5 inline-flex items-center gap-2" data-testid="hist-predict"><Zap size={16} /> OPEN PREDICTOR</button>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((p) => (
            <div key={p.id} className="vw-card p-5" data-testid={`history-item-${p.id}`}>
              <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
                <span className="text-xs text-slate-500 font-mono">{new Date(p.created_at).toLocaleString()}</span>
                <span className="text-xs text-emerald-400 font-mono">{p.plan_used}</span>
              </div>
              <div className="flex gap-4 flex-col sm:flex-row">
                {p.screenshot_base64 && (
                  <img src={p.screenshot_base64} alt="fixture" className="w-full sm:w-32 h-24 object-cover rounded-lg border border-slate-800" />
                )}
                <div className="flex-1 space-y-2">
                  {p.fixtures.map((f, i) => (
                    <div key={i} className="flex items-center justify-between gap-3 text-sm">
                      <span className="text-slate-200">{f.home_team} <span className="text-slate-500">vs</span> {f.away_team}</span>
                      <PredictionPill prediction={f.prediction} />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
